import { useEffect, useState } from 'react';
import FeatureFlag from '../components/form/feature-flag/FeatureFlag';
import { FeatureFlagRequest } from '../services/connectors/FeatureFlagRequest';
import { ContactFormConnector } from '../services/connectors/ContactFormConnector';
import { KeycloakContextHolder } from '../components/context/KeycloakContext';
import {
  Experimentation,
  SUPPORTED_FEATURE_FLAGS,
} from '../components/context/ExperimentationContext';

export function useExperimentation(keycloakContext: KeycloakContextHolder, domain: string) {
  const [experimentation, setExperimentation] = useState(new Experimentation([], domain));
  const [areFeatureFlagsProvided, setFeatureFlagsProvided] = useState(false);

  useEffect(() => {
    if (!!keycloakContext.tokenData?.token && !areFeatureFlagsProvided) {
      const request = new FeatureFlagRequest(domain, SUPPORTED_FEATURE_FLAGS);
      new ContactFormConnector()
        .requestFeatureFlags(request)
        .then((featureFlagResponses) =>
          featureFlagResponses.map((it) => new FeatureFlag(it.key, it.variation, it.enabled)),
        )
        .then((featureFlags) => {
          setExperimentation(new Experimentation(featureFlags, domain));
          setFeatureFlagsProvided(true);
        })
        .catch(() => {
          setExperimentation(new Experimentation([], domain));
        });
    }
  }, [areFeatureFlagsProvided, keycloakContext, domain]);

  return experimentation;
}
